import { Box, Flex, Image } from '@chakra-ui/react'
import logo from '../../assets/logo-alt.svg'
import PrinterConfig from './PrinterConfig'
import { PropsInitial } from './types'

export default function Navbar({ text, children, component }: PropsInitial) {
    return (
        <Box
            w="full"
            bg="dark"
            color="white"
            h="60px"
            display="flex"
            justifyContent="space-between"
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
                px="10"
                gridGap={{
                    base: '10px',
                    lg: '100px'
                }}
            >
                <Box display={{ base: 'none', xl: 'block' }}>
                    <Image w="50px" h="auto" src={logo} alt="logo"></Image>
                </Box>
                {text && (
                    <Box fontSize="xl" fontWeight="bold">
                        {text}
                    </Box>
                )}
                {component && <>{component}</>}
            </Flex>
            <Flex alignItems="center">
                <PrinterConfig />
                {children}
            </Flex>
        </Box>
    )
}
